module.exports = __webpack_public_path__ + "img/11_paul_n.8c76e73e.png";